import React, { createContext, useState } from 'react';
import jwtDecode from 'jwt-decode'; // ✅ Make sure installed
import { displayErrors } from '../config/display';
import axios from 'axios';

export const Utils = createContext({});

const UtilsContext = ({ children }) => {
	const [loading, setLoading] = useState(false);
	const [units, setUnits] = useState([]);

	const API = process.env.REACT_APP_API_URL || 'http://api.exelpack.site/api/';

	// ✅ Token getter
	const getToken = () => localStorage.getItem('token');

	// ✅ Decode token
	const decodedToken = () => {
		try {
			const token = getToken();
			if (!token) return null;
			return jwtDecode(token);
		} catch (err) {
			console.error('Invalid token:', err);
			return null;
		}
	};

	// ✅ Get option units from API
	const getOptionUnits = async () => {
		try {
			const res = await axios.get(API + 'options/units');
			setUnits(res.data.unitsOption);
		} catch (err) {
			displayErrors(err);
		}
	};

	return (
		<Utils.Provider
			value={{
				loading,
				setLoading,
				getOptionUnits,
				unitsOpt: units,
				decodedToken, // ✅ now available in other components
			}}
		>
			{children}
		</Utils.Provider>
	);
};

export default UtilsContext;
